import React, { useState } from "react";
import { MDBCol, MDBRow } from "mdbreact";
import { Button } from "evergreen-ui";
import Firebase from "../../../Firebase/Firebase";
import { Form, Select, Input, message } from "antd";
import { useListVals } from "../../../Firebase/databaseHooks";
import { getDatabase, ref } from "firebase/database";
import { v4 as uuidv4 } from 'uuid';
import { filterSelectOption, sortSelectOptions } from "../../../utils/selectOptions.js";

const db = getDatabase(Firebase);

const ProvincesActionLayout = (props) => {
  const [form] = Form.useForm();
  const [name, setName] = useState("");
  const [showLoading, setShowLoading] = useState(false);
  const [countries = [], loadingCountries] = useListVals(ref(db, "talmidsdb/countries"));

  const handleCreate = async (values) => {
    try {
      setShowLoading(true);
      const id = uuidv4();
      const payload = {
        id,
        countryID: values.countryID,
        provinceName: values.provinceName
      };

      form.resetFields();
      setName("");
      await props.createCallback("province", id, payload);
    } catch (error) {
      console.error("Error creating province:", error);
      message.error("Failed to create province");
    } finally {
      setShowLoading(false);
    }
  };

  return (
    <div className="font-Nunito">
      <MDBRow>
        <MDBCol className="px-4">
          <Form
            form={form}
            layout="vertical"
            onFinish={handleCreate}
          >
            <Form.Item
              label="Enter Province name"
              name="provinceName"
              rules={[{ required: true, message: 'Please enter province name' }]}
              className="d-flex flex-column my-2 mt-3"
            >
              <Input
                className="w-100"
                name="text-input-name"
                placeholder="Enter province name"
                onChange={(e) => setName(e.target.value)}
                value={name}
              />
            </Form.Item>

            <Form.Item
              label="Select Country"
              name="countryID"
              rules={[{ required: true, message: 'Please select a country' }]}
              className="d-flex flex-column my-2 mt-3"
            >
              <Select
                placeholder="Select Country"
                loading={loadingCountries}
                showSearch
                optionFilterProp="children"
                filterOption={filterSelectOption}
                filterSort={sortSelectOptions}
              >
                {countries.map((item) => (
                  <Select.Option value={item.id} key={item.id}>
                    {item.countryName}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            <Button
              appearance="primary"
              htmlType="submit"
              className="mt-2"
              isLoading={showLoading}
            >
              Add
            </Button>
          </Form>
        </MDBCol>
      </MDBRow>
    </div>
  );
}

export default ProvincesActionLayout;